import UrlHelper from '../../common/helpers/urlHelpers'
import { Config } from '../core/config'
import Controller from './flow'
import { model } from '../core/model'
import Analytics from '../helpers/analytics'

const mapUrl = function () {
    let route;
    let encontro = false;
    let path = UrlHelper.getURLPath();
    try {
        for (route in Config.Routes) {
            route = Config.Routes[route];
            //console.log(route);
            if (path.toUpperCase() === route.path.toUpperCase()) {
                if (route.validaModo == null || !route.validaModo || (route.modo === model.Window.modo)) {
                    if (!route.combo || (route.combo === model.Window.combo)) {
                        model.Window.setModo(route.modo);
                        let routeSource = route.source;
                        if (model.Usuario.Segmento !== Config.SegmentoDefault && route.trackSegmento) routeSource += "_segmentado";
                        model.Window.setSource(routeSource);
                        encontro = true;
                        //siempre tiene prioridad el seteado en la url(que esta en el model), sino tiene le asigno el default para la ruta
                        model.Window.mapFormadeContacto(route.formaContacto);
                        model.Window.mapCanaldeVenta(route.canaldeVenta);
                        //console.log('MODEL',model.ProductCategory)
                        model.mapProductCategory(route.productCategory);
                        //console.log('UPDATED',model.ProductCategory)
                        break;
                    }
                }
            }
        }
    } catch (ex) {
        //logger && logger.error('MapUrl | Error (' + modo + ')', ex);
    }

    if (!encontro) {
        //logger && logger.error('MapUrl | No existe el modo', { "modo": modo, "path" : path });
        window.mostrar_error( { 
            error: `Router.MapUrl | No se encuentra la ruta - modo: ${model.Window.modo}, path : ${path}` 
        })
    }
}

const init = function () {
    mapUrl();
    switch (model.Window.modo) {
        case 'V':
        case 'E':
            Analytics.trackViewPaywall();
            Controller.flowA();
            break;
        case 'I':   
        case 'A':
        case 'F':
            Controller.flowABis();
            showReturnButton();
            break;
        case 'S':
            Controller.flowS();
            break;
        default:
            window.mostrar_error( { 
                error: `Router.init | No existe el modo, modo: ${model.Window.modo}` 
            })
    }

}

const showReturnButton = function () {
    if (UrlHelper.testMatchURL(document.referrer)) {
        let linkVolver = document.getElementsByClassName("volver")[0];
        linkVolver.style.display = "block";
        linkVolver.setAttribute("href", document.referrer);
    }
}

export default { init}


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/controllers/router.js